<ng-container *transloco="let t">
  @if (displayLargeMobileFooter || currentWindowWidth > 1400) {
    <footer class="footer-container container-fluid pb-3 pt-3 pt-lg-5">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-4">
            <p class="light pb-2 pb-lg-4 fs-18">{{t('footer.service.provider')}}</p>
            <ul class="list-unstyled">
              <li class="pb-2 pb-lg-4">
              <a [routerLink]="[CONTACT_ROUTE]">{{t('app.common.headquartersName')}}</a></li>
              <li><a >{{
                  environment.headquartersStreet + ', ' +
                  environment.headquartersCity + ' (' + t('app.common.headquartersCounty') + ')'
                }}</a></li>
              <li class="pb-2 pb-lg-4"><a href="mailto: {{environment.contactMail}}">
                  {{t("about.us.contact") + ': ' + environment.contactMail}}</a></li>
            </ul>
          </div>
          <div class="col-12 col-lg-4 py-4 py-lg-0">
            <p class="light pb-3 d-none d-lg-flex fs-18">{{t('footer.about.title')}}</p>
            <ul class="list-unstyled">
              <li class="pb-2 pb-lg-4"><a [routerLink]="[ABOUT_ROUTE]">{{t('footer.about.title')}}</a></li>
              <li class="pb-2 pb-lg-4">
                <a href="mailto:{{environment.contactMail}}?subject={{t('footer.feedback.thanks')}}">
                    {{t('footer.feedback.thanks')}}
                </a>
               </li>
              <li><a href="mailto: {{environment.contactMail}}">{{t('footer.need.help')}}</a></li>
            </ul>
          </div>
          <div class="col-12 col-lg-4">
            <p class="light pb-2 pb-lg-4 fs-18">{{t('footer.products')}}</p>
            <ul class="list-unstyled">
              <li class="pb-2 pb-lg-4"><a [routerLink]="[LANDING_ROUTE]">{{t('footer.products.public')}}</a></li>
              <li class="pb-2 pb-lg-4"><a (click)="goToPrivate()">{{t('footer.products.private')}}</a></li>
              <li><a (click)="goToAdmin()">{{t('footer.products.admin')}}</a></li>
            </ul>
          </div>
        </div>
        <div class="d-none d-lg-flex">
          <div class="row pt-5">
            <div class="container">
              <ul class="list-unstyled d-flex">
                <li class="me-5"><a [routerLink]="[GENERAL_CONDITIONS_ROUTE]"><p class="small light">
                  {{t("policy.general.conditions")}} </p></a></li>
                <li class="me-5"><a [routerLink]="[PERSONAL_DATA_PROTECTION]"><p class="small light">{{
                        t("policy.notice.on.personal.data.protection")
                    }}</p></a></li>
                <li class="me-5"><a [routerLink]="[INTELLECTUAL_PROPERTY_ROUTE]"><p class="small light">{{
                    t("policy.intellectual.property")
                  }}</p></a></li>
                <li class="me-5"><a [routerLink]="[COOKIE_POLICY_ROUTE]"><p class="small light">{{
                    t("policy.cookie")
                  }}</p></a></li>
                <li class="me-5"><a [routerLink]="[COMPLAINTS_AND_DISPUTES]"><p class="small light">{{
                    t("policy.complaints.and.disputes")
                  }}</p></a></li>

              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  }

  <div class="container-fluid copyright text-center text-white">
      <div class="container">
        <div class="d-flex justify-content-start align-items-center my-2 ps-2">
          <div>
            <span class="fs-18 fw-300 text-white">
              {{t("footer.admin.for.organisers")}}
            </span>
            <a class="small text-white light ps-4 d-inline opacity-07" (click)="goToAdmin()">
              {{t("footer.earn.money")}}
            </a>
          </div>
        </div>
      </div>
  </div>

  <div class="container-fluid copyright text-center text-white">
    @if (!displayLargeMobileFooter) {
      <div class="d-flex align-items-center justify-content-center w-100 d-xxl-none pt-2">
        <img src="assets/icons/tracey-alt-logo.svg" alt="Tracey logo" [style.height]="'56px'">
      </div>
    }
    <div class="container">
      <div class="d-flex justify-content-center">
        <div>
          <p class="small light pe-2 d-inline opacity-07">
            {{'Copyright © '}}
            <img src="assets/icons/tracey-alt-logo.svg" alt="Tracey logo" [style.height]="'36px'">
            {{
              ' 2025.(' + getClientVersion() + (FooterComponent.backendVersion ? '-' + FooterComponent.backendVersion
                : '') + ')'
            }}
          </p>
          <a href="https://www.byteink.hr/" target="_blank" rel="noopener noreferrer">
            <img src="assets/img/svg/byteink_footer.svg" alt="ByteInk">
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-container>


